module.exports = __webpack_public_path__ + "img/gamic-text.37fa2a4c.png";